import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get} from '../../request'
import './styles.scss';


function Select({ initialValue, options, className, name, onChange, placeholder   }) {
    const [value, setValue] = useState(initialValue);
    
    useEffect(() => {
        if (initialValue !== value) {
            setValue(initialValue);
        }
    }, [initialValue]);
    const handleChange = (event) => {
        setValue(event.target.value);
        onChange(name ,event.target.value);
    };
   
    return (
        <select className={`select-field ${className}`} name={name} value={value} onChange={handleChange} >
            {placeholder && <option value="" disabled >{placeholder}</option> }
            {options.map((option) => (
                <option key={option.id} value={option.id}>
                    {option.name}
                </option>
            ))}
        </select>
    );
};

export default Select;